<template>
  <div class="empty-cart">
    <img
      :src="img"
      :alt="description"
    >
    <h2>{{ description }}</h2>
    <div
      v-if="button"
      class="actions"
    >
      <router-link
        id="btnEmptyCart"
        :to=" action !== 'null' ? { name: 'Samples', query: { printed: stringToBoolean(action) } } : '/dashboard' "
        class="md-button btn btn-secondary"
        :exact="true"
        replace
      >
        {{ button }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ['description', 'button', 'action', 'img'],
  methods: {
    stringToBoolean (string) {
      if (string === 'true') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/components/orders/empty-cart";
</style>
